import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Layers, X } from "lucide-react";

// Small floating legend explaining marker colors — helps first-time users
// understand what green/red/purple pins mean without tapping every marker.
export default function MapLegend({ categories }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="map-legend-wrap" data-testid="map-legend-wrap">
      <motion.button
        whileTap={{ scale: 0.92 }}
        onClick={() => setOpen((o) => !o)}
        className="w-10 h-10 bg-white rounded-full shadow-lg ring-1 ring-slate-200 flex items-center justify-center text-slate-600 hover:bg-slate-50"
        aria-label="Toggle map legend"
        data-testid="legend-toggle-btn"
      >
        {open ? <X size={18} /> : <Layers size={18} />}
      </motion.button>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 8, scale: 0.96 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 8, scale: 0.96 }}
            transition={{ duration: 0.15 }}
            className="mt-2 bg-white/95 backdrop-blur-sm rounded-xl shadow-lg ring-1 ring-slate-200 p-3 w-48"
            data-testid="map-legend-panel"
          >
            <p className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">
              Map Legend
            </p>
            <div className="space-y-1.5 max-h-64 overflow-y-auto pr-1">
              {categories.map((c) => (
                <div key={c.key} className="flex items-center gap-2" data-testid={`legend-item-${c.key}`}>
                  <span
                    className="w-3 h-3 rounded-full flex-shrink-0 ring-1 ring-black/5"
                    style={{ backgroundColor: c.color }}
                  />
                  <span className="text-xs text-slate-700 truncate">{c.label}</span>
                </div>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
